import type { GoogleDriveFile, ParentFolderContext } from './types';
import { googleFetch } from '../client';

export type GoogleDriveFoldersCreateRequest = ParentFolderContext & {
  name: string;
};

export type GoogleDriveFoldersCreateResponse = GoogleDriveFile;

export async function googleDriveFoldersCreate(
  params: GoogleDriveFoldersCreateRequest
): Promise<GoogleDriveFoldersCreateResponse> {
  return googleFetch<GoogleDriveFoldersCreateResponse>(
    '/rpc/google_drive_folders_create',
    {
      body: params,
    }
  );
}
